import { render, staticRenderFns } from "./OrgsListing.vue?vue&type=template&id=4f64cf41&scoped=true&"
import script from "./OrgsListing.vue?vue&type=script&lang=js&"
export * from "./OrgsListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f64cf41",
  null
  
)

export default component.exports